<template>
  <div></div>
</template>

<script>
export default {
  name: 'CloudOrders',
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style scoped lang="less">
</style>